import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { styled, Switch as MuiSwitch, switchClasses, Typography } from '@mui/material';
var StyledSwitch = styled(MuiSwitch)(function (_ref) {
  var theme = _ref.theme;

  var styles = _defineProperty({
    margin: theme.typography.pxToRem(-12)
  }, "& .".concat(switchClasses.switchBase), _defineProperty({
    color: theme.colors.seaGreen,
    '& + .MuiSwitch-track': {
      backgroundColor: theme.colors.seaGreen
    }
  }, "&.".concat(switchClasses.checked), {
    color: theme.colors.seaGreen,
    '& + .MuiSwitch-track': {
      backgroundColor: theme.colors.whisper,
      opacity: 'unset'
    }
  }));

  return styles;
});
var StyledSwitchLabel = styled(Typography)(function (_ref2) {
  var theme = _ref2.theme;
  var styles = {
    fontSize: theme.typography.pxToRem(14),
    lineHeight: theme.typography.pxToRem(24),
    color: theme.palette.text.secondary
  };
  return styles;
});
export { StyledSwitch, StyledSwitchLabel };